import imageOne from "./assets/images/assets-biz-icon.webp";
import imageTwo from "./assets/images/assets-biz-image.webp";

export const config = {
  title: "ROMERO'S REMODELING LLC | Seattle, WA",
  meta: {
    description:
      "ROMERO'S REMODELING LLC - Transforming spaces, building perfection in Seattle, WA. 23+ years of expert craftsmanship and unmatched quality in home remodeling. Trust, excellence, and customer satisfaction.",
    keywords: [
      "ROMERO'S REMODELING LLC",
      "Home Remodeling Seattle",
      "Kitchen Remodeling",
      "Bathroom Renovation",
      "Seattle Contractor",
      "Home Renovation WA",
      "Expert Craftsmanship",
      "Quality Remodeling",
      "Romero's Remodeling"
    ],
    author: "ROMERO'S REMODELING LLC",
    canonicalUrl: "https://romerosremodelingwa.com/",
  },
  sections: {
    header: {
      businessName: "ROMERO'S REMODELING LLC",
    },
    sectionB: {
      heroTitle: "Transforming Spaces, Building Perfection",
      heroSubtitle: "Expert Craftsmanship and Unmatched Quality in Seattle, WA",
      learnAboutText: "Schedule a Consultation",
      phoneNumber: "2064379017",
      phoneLabel: "(206) 437-9017",
      heroBackgroundImage:
        "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?q=80&w=2070&auto=format&fit=crop",
      cardData: [
        {
          title: "23+ Years Experience",
          description:
            "Over two decades of expertise redefining the remodeling industry in Seattle with unparalleled craftsmanship.",
        },
        {
          title: "Expert Craftsmanship",
          description:
            "Skilled professionals committed to delivering exceptional results that exceed expectations on every project.",
        },
        {
          title: "Unmatched Quality",
          description:
            "Using the latest techniques and materials to transform your space into a beautiful and functional masterpiece.",
        },
      ],
      description:
        "ROMERO'S REMODELING LLC transforms homes in Seattle, WA with expert craftsmanship and unmatched quality. Our team of skilled professionals delivers exceptional results built on trust, excellence, and customer satisfaction.",
    },
    sectionC: {
      servicesTitle: "Our Remodeling Services",
      servicesDescription:
        "Comprehensive home renovation services delivered with integrity, reliability, and commitment to quality. Making us your trusted partner in home transformation.",
      cards: [
        {
          title: "Kitchen Remodeling",
          description:
            "Transform your kitchen into a stunning and functional space with our expert design, quality materials, and meticulous attention to detail.",
          imageSrc: "https://images.unsplash.com/photo-1556911220-bff31c812dba?q=80&w=2068&auto=format&fit=crop",
          imageAlt: "Kitchen Remodeling Services",
        },
        {
          title: "Bathroom Renovation",
          description:
            "Create your perfect bathroom oasis with our professional renovation services, combining style, comfort, and superior craftsmanship.",
          imageSrc: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?q=80&w=2187&auto=format&fit=crop",
          imageAlt: "Bathroom Renovation Services",
        },
        {
          title: "Complete Home Remodeling",
          description:
            "Full-scale home renovations that bring your vision to life, transforming your entire living space into a beautiful masterpiece.",
          imageSrc: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=2070&auto=format&fit=crop",
          imageAlt: "Complete Home Remodeling",
        },
      ],
      otherServicesTitle: "Additional Services",
      otherServicesList: [
        "Closet Installations",
        "Flooring Installation",
        "Interior Design Consultation",
        "Custom Carpentry",
        "Home Improvement Projects",
      ],
    },
    sectionD: {
      aboutTitle: "About ROMERO'S REMODELING LLC",
      aboutImage: {
        src: imageTwo,
        alt: "ROMERO'S REMODELING LLC Team",
      },
      aboutText: [
        "For over 23 years, ROMERO'S REMODELING LLC has been redefining the remodeling industry in Seattle, WA through unparalleled expertise and excellence. Our team of trusted professionals possess a deep understanding of the unique challenges and opportunities that come with remodeling in this vibrant city.",
        "We take pride in delivering top-quality services, using the latest techniques and materials to bring your vision to life. Our company is built on the values of trust, excellence, and customer satisfaction. We believe in conducting our business with integrity, always delivering on our promises and ensuring transparency with our clients. With our unwavering commitment to excellence, you can trust us to transform your space into a beautiful and functional masterpiece.",
      ],
    },
    sectionE: {
      profileImage: imageOne,
      profileAlt: "ROMERO'S REMODELING LLC",
      businessName: "ROMERO'S REMODELING LLC",
      contact: {
        phone: "2064379017",
        phoneLabel: "(206) 437-9017",
        email: "Remodelingromeros9@gmail.com",
        website: "https://romerosremodelingwa.com/",
        address: "Seattle, WA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Seattle, WA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d172285.8!2d-122.3321!3d47.6062!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x5490102c93e83355%3A0x102565466944d59a!2sSeattle%2C%20WA!5e0!3m2!1sen!2sus!4v1730400000000!5m2!1sen!2sus",
    },
  },
};

export default config;